import Vue from 'vue'
import App from './App.vue'
import router from './router'
import InstantSearch from 'vue-instantsearch';
import firebase from 'firebase/app'
import 'firebase/firestore'
import { firestorePlugin } from 'vuefire'
import vueSmoothScroll from 'vue2-smooth-scroll'
import Vuelidate from 'vuelidate'
import VueScrollmagic from 'vue-scrollmagic'
import VueTheMask from 'vue-the-mask'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSplide from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

import moment from 'moment'

Vue.use(Vuelidate);
Vue.use(InstantSearch);
Vue.use(firestorePlugin);
Vue.use(vueSmoothScroll);
Vue.use(moment);
Vue.use(VueScrollmagic);
Vue.use(VueTheMask)
Vue.use(VueAxios, axios)
Vue.use(VueSplide);




// Get a Firestore instance
export const db = firebase.initializeApp({
    apiKey: "AIzaSyBw7qV-Um-XDmpg41rlf1vXb1NMy5KTHmU",
    authDomain: "vacuum-center.firebaseapp.com",
    databaseURL: "https://vacuum-center.firebaseio.com",
    projectId: "vacuum-center",
    storageBucket: "vacuum-center.appspot.com",
    messagingSenderId: "189572443479",
    appId: "1:189572443479:web:078c2c280e84cae07b2212"
}).firestore()

Vue.prototype.$firebase = firebase;
Vue.prototype.$db = db;
Vue.prototype.$moment = moment;
// Vue.prototype.$admin = admin;

Vue.filter('specificationFormat', function(value) {
    let res = '';
    if (value.min && value.max) {
        res = value.min + ' à ' + value.max;
    } else if (value.min && !value.max) {
        res = value.min
    } else if (!value.min && value.max) {
        res = 'até ' + value.max
    }
    if (value.metric) {
        res += ' ' + value.metric
    }
    return res

})
Vue.config.productionTip = false

let app = '';
firebase.auth().onAuthStateChanged(() => {
    Vue.prototype.$user = firebase.auth().currentUser;
    if (!app) {
        app = new Vue({
            router,
            data() {
                return {
                    user: null,
                    isInvisible: false,
                    cart: null,
                    company: null,
                    updated: false,
                    alerts: []
                }
            },
            render: h => h(App)
        }).$mount('#app')
    }
})